import { css } from '@/styled-system/css';

export const sliderActiveTrackStyles = css.raw({
  position: 'absolute',
  width: '100%',
  height: 'Slider.Track.height',
  borderRadius: 'Slider.Track',
  pointerEvents: 'none',
  background: 'Slider.Track.bg.active',
});
